import Keycloak from "keycloak-js";
import defaultConfig from "./default-config";

const keycloakUrl =
  window.env && window.env.KEYCLOAK_URL
    ? window.env.KEYCLOAK_URL
    : defaultConfig.keycloak.url;
const keycloakRealm =
  window.env && window.env.KEYCLOAK_REALM
    ? window.env.KEYCLOAK_REALM
    : defaultConfig.keycloak.realm;
const keycloakClientId =
  window.env && window.env.KEYCLOAK_CLIENTID
    ? window.env.KEYCLOAK_CLIENTID
    : defaultConfig.keycloak.clientId;

export const keycloak = new Keycloak({
  url: keycloakUrl,
  realm: keycloakRealm,
  clientId: keycloakClientId
});

// Função temPermissao mantida para compatibilidade (não é mais usada no React Router v6)
export const temPermissao = () => {
  // A verificação de permissão agora é feita pelo componente PrivateRoute
  return true;
};
